import { Avatar, Box, Stack, Typography } from '@mui/material';
import { useAuthContext } from '../../../auth/useAuthContext';
import { getRoleDisplayName } from '../../../auth/types/roles';

// Role → colour mapping so each badge is visually distinct
const ROLE_COLOURS: Record<string, string> = {
  receptionist: '#1565C0',
  assistant:    '#1565C0',
  clinician:    '#2E7D32',
  professional: '#2E7D32',
  manager:      '#6A1B9A',
  accountant:   '#6A1B9A',
  admin:        '#B71C1C',
  sys_manager:  '#B71C1C',
  marketing:    '#E65100',
  patient:      '#00695C',
  lab:          '#4E342E',
};

export default function NavDocs() {
  const { user } = useAuthContext();

  if (!user) return null;

  const roleId     = user.roleId ?? '';
  const roleName   = getRoleDisplayName(roleId);
  const roleColour = ROLE_COLOURS[roleId] ?? '#455A64';

  const nameParts = [user.firstName, user.lastName].filter((n): n is string => !!n);

  const initials = nameParts.map((n) => n[0].toUpperCase()).join('') || '?';
  const fullName = nameParts.join(' ') || user.email;

  return (
    <Stack
      spacing={1.5}
      sx={{
        px: 2.5,
        pb: 3,
        mt: 3,
        mx: 1,
        borderRadius: 2,
        bgcolor: 'background.neutral',
      }}
    >
      {/* divider line */}
      <Box sx={{ borderTop: '1px dashed', borderColor: 'divider', pt: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              fontSize: 13,
              fontWeight: 700,
              bgcolor: roleColour,
              flexShrink: 0,
            }}
          >
            {initials}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              noWrap
              sx={{ lineHeight: 1.3, color: 'text.primary' }}
            >
              {fullName}
            </Typography>

            <Box
              sx={{
                display: 'inline-block',
                mt: 0.4,
                px: 0.9,
                py: 0.2,
                borderRadius: 0.75,
                bgcolor: roleColour,
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: '#fff', fontWeight: 600, lineHeight: 1.4 }}
              >
                {roleName}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
}
